<template>
  <div class="signup-view">

    <AccountsSignupOperation
      ref="operation"

      @userProfileFetched="userProfileFetched"
      @operationCancelled="operationCancelled"
      @operationCompleted="operationCompleted"
    >
    </AccountsSignupOperation>

    <div class="avatar">
      <UserTopBarAvatar
        v-if="showAvatar"
        ref="avatar"

        hide-login-links
      >

        <li class="mdc-list-item static" role="menuitem">
          <a href="/login/"><h4>{{ gettext('Login') }}</h4></a>
        </li>

      </UserTopBarAvatar>
    </div>

  </div>
</template>

<script>
import GettextMixin from '@paiuolo/pai-vue-gettext/mixins/GettextMixin'
import UserTopBarAvatar from 'q-custom-elements/src/components/entities/user/UserTopBarAvatar'

import AccountsSignupOperation from '../components/step-operations/AccountsSignupOperation'


export default {
  name: 'SignupView',
  mixins: [
    GettextMixin
  ],
  components: {
    AccountsSignupOperation,
    UserTopBarAvatar
  },
  props: {
    showAvatar: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      title: this.gettext('Signup'),
      userProfile: null
    }
  },
  mounted () {
    // console.log('ROUTE', this.$route)
  },
  methods: {
    userProfileFetched (p) {
      if (p) {
        this.setLocale(p.language)
        this.userProfile = p
      }
    },
    operationCancelled () {
    },
    operationCompleted () {
    }
  }
}
</script>

<style lang="scss">
@import "q-custom-elements/src/scss/accounts.theme";

.signup-view {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;

  .avatar {
    position: fixed;
    top: 0;
    right: 0;
    margin: 1em;

    border: 4px solid #fff;
    border-radius: 999px;
    z-index: 2;

    width: 32px;
    height: 32px;

    @media (min-width: $break-phone){
      width: 48px;
      height: 48px;
    }

    @media ( max-height: 520px ) and (max-width: 420px){
      margin: 8px;
    }
  }
  .avatar:hover {
    box-shadow: 0 0 4px #fff;
  }
}
</style>
